import { getUserClassPath } from 'approot/classes/classes.apollo';
import * as Styled from './content-page-archived-banner.style';
import { LinkStyled } from 'approot/shared/styles/typography.style';

const ContentPageArchivedBanner = ({ slug }: { slug: string }) => {
  return (
    <Styled.ContentPageArchivedBanner>
      The activities you’re viewing have been archived.{' '}
      <LinkStyled to={getUserClassPath(slug)}>Visit the unit page</LinkStyled>{' '}
      to explore the latest content.
    </Styled.ContentPageArchivedBanner>
  );
};

export default ContentPageArchivedBanner;
